/**
 * モーダルプラグイン modaalの設定
 * https://github.com/humaan/Modaal
 */

$(document).ready(function () {
  // 動画用スクリプト
  $('.modal_video').modaal({
    type: 'video'
	});

	  $('.modal_video_trigger').modaal({
        type: 'inline',
        background: '#000', // モーダルの背景色
        overlay_opacity: 0.8, // オーバーレイの不透明度
        custom_class: 'video_modal',
        before_open: function() {
            // モーダルが開く前にビデオを再生する
            var video = $('#modal_video video')[0];
            video.play();
        },
        after_close: function() {
            // モーダルが閉じた後にビデオを停止する
            var video = $('#modal_video video')[0];
            video.pause();
            video.currentTime = 0;
        }
    });


  $('.modal-gallery').modaal({
        type: 'image',
    });

});
// document.addEventListener("DOMContentLoaded", function() {
//     const updateModalElements = () => {
//         const movieArea = document.querySelector('.p-modelhouse .movie-area');

//         if (!movieArea) return; // .movie-areaが存在しない場合は処理を中止

//         const modalVideos = movieArea.querySelectorAll('.modal_video');
//         const modalVideoTriggers = movieArea.querySelectorAll('.modal_video_trigger');

//         const viewportWidth = window.innerWidth;

//         // min-width: 992px の場合に .modal_video_trigger を削除
//         if (viewportWidth >= 992) {
//             modalVideoTriggers.forEach(modalVideoTrigger => {
//                 modalVideoTrigger.remove(); // DOMから要素を削除
//             });
//         }

//         // max-width: 991px の場合に .modal_video を削除
//         if (viewportWidth <= 991) {
//             modalVideos.forEach(modalVideo => {
//                 modalVideo.remove(); // DOMから要素を削除
//             });
//         }
//     };

//     // ページ読み込み時とリサイズ時に実行
//     updateModalElements();
//     window.addEventListener('resize', updateModalElements);
// });
